import { fetchAllowedCountriesForShop } from '../api/shop-access.api'
import { useAuthFetchWithResponse } from '@e3dc-react/shell/Hooks/AuthFetch'
import { CACHE_TIME } from 'src/Libs/installations/constants'
import { ShopAccessDto } from '../api/dto/shop-access.dto'
import { usePortalQuery } from 'src/Libs/api'

/**
 * Hook to fetch countries that have web shop access
 */
export const useShopAllowedCountries = (): [ShopAccessDto[], boolean, boolean] => {
  const authFetch = useAuthFetchWithResponse()

  const fetchAllowedCountriesForShopQueryFn = async (): Promise<ShopAccessDto[] | null> => {
    const { error, hasErrors, value } = await fetchAllowedCountriesForShop(authFetch)

    if (hasErrors) {
      throw error || new Error('An unexpected error occurred when fetching allowed countries for shop')
    }

    return value
  }

  const { data, isLoading, isError } = usePortalQuery({
    queryKey: ['users', 'shop-accesses'],
    queryFn: fetchAllowedCountriesForShopQueryFn,
    staleTime: CACHE_TIME,
  })

  return [data || [], isLoading, isError]
}
